import RestStore from "@shared/svelte/Stores/RestStore";

export default function QuickOrderListStore(initial: any, getUrl = null, updateUrl = null) {
  const store = RestStore(
    initial,
    "/api/retailer/quick_order_lists",
    "quick_order_list",
    getUrl,
    updateUrl,
  );
  return store;
}
